import { render, staticRenderFns } from "./PopularItem.vue?vue&type=template&id=04ad09b1&"
import script from "./PopularItem.vue?vue&type=script&lang=js&"
export * from "./PopularItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports